import script from "./ProductSpot.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSpot.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__